import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { Checkbox, FormControlLabel, SxProps } from '@mui/material';
import { ChangeEvent } from 'react';

export type ControlledCheckboxProps = {
  control: Control<any>;
  name: string;
  label: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
};

export default function ControlledCheckbox({
  control,
  name,
  label,
  disabled = false,
  onChange,
  sx
}: ControlledCheckboxProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <FormControlLabel
            disabled={disabled}
            label={label}
            control={
              <Checkbox
                {...field}
                checked={!!field.value}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  field?.onChange(event);
                  onChange?.(event);
                }}
                sx={sx}
              />
            }
          />
        );
      }}
    />
  );
}
